.card {
    max-width: 100%;
    overflow: hidden;
}

.cardCollapsedNoBorder {
    border-color: transparent;
}

.header {
    padding: var(--mantine-spacing-sm) var(--mantine-spacing-lg);
    background-color: var(--dib-surface);
    border-bottom: 1px solid var(--mantine-color-default-border);
    transition:
        background-color 200ms ease,
        border-radius 200ms ease;
}

.headerCollapsible {
    cursor: pointer;
}

.headerClosed {
    background-color: transparent;
    border-bottom-color: transparent;
    border-radius: 0;
}

.headerClosed:hover {
    background-color: var(--mantine-color-gneis-0);
}

.expandHint {
    margin-left: auto;
    color: var(--mantine-color-dibblue-7);
    flex-shrink: 0;
}

.expandHintIcon {
    transition: transform 200ms ease;
}

.expandHintIconUp {
    transform: rotate(180deg);
}

.resultsPill {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 32px;
    height: 22px;
    padding: 0 8px;
    border-radius: var(--mantine-radius-xl);
    background-color: var(--mantine-color-gneis-1);
    color: var(--mantine-color-dibblue-9);
    font-size: var(--mantine-font-size-xs);
    font-weight: 600;
    line-height: 1;
    flex-shrink: 0;
}

.resultsPillLoader {
    /* Lock pill geometry so the dots loader doesn't change its width or height. */
    width: 24px;
    height: 14px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
}

.headerIcon {
    color: var(--mantine-color-dibblue-9);
}

.resultRow {
    width: 100%;
    display: block;
    padding: var(--mantine-spacing-md) var(--mantine-spacing-md);
    transition: background-color 150ms ease;
}

.resultRow:hover {
    background-color: var(--mantine-color-gneis-0);
}

:global([data-mantine-color-scheme="dark"]) .resultRow:hover {
    background-color: var(--mantine-color-dark-5);
}

.resultRowBorder {
    border-top: 1px solid var(--mantine-color-default-border);
}

.resultNumber {
    min-width: 1rem;
    text-align: right;
    flex-shrink: 0;
}

.resultTitle {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.chevronRight {
    flex-shrink: 0;
    color: var(--mantine-color-dimmed);
    transform: rotate(-90deg);
}

.typeBadge {
    flex-shrink: 0;
    font-size: var(--mantine-font-size-xs);
    font-weight: 500;
    color: var(--mantine-color-dark-5);
    padding: 2px 8px;
    border-radius: var(--mantine-radius-sm);
    border: 1px solid var(--mantine-color-gray-5);
    white-space: nowrap;
    line-height: 1.4;
}

@media (max-width: 48em) {
    .typeBadge {
        display: none;
    }
}

.expandIcon {
    color: var(--mantine-color-dibblue-7);
    transition: transform 200ms ease;
}

.expandIconUp {
    transform: rotate(180deg);
}

.expandButton {
    width: 100%;
    padding: var(--mantine-spacing-sm) var(--mantine-spacing-lg);
    transition: background-color 150ms ease;
}

.expandButton:hover {
    background-color: var(--mantine-color-gneis-0);
}

:global([data-mantine-color-scheme="dark"]) .expandButton:hover {
    background-color: var(--mantine-color-dark-5);
}

.collapseChevron {
    transition: transform 200ms ease;
}

.collapseChevronClosed {
    transform: rotate(-90deg);
}
